/* Metacards motion — logo scroll story, plastic vs steel slider, wall of cards. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v) { return Math.max(0, Math.min(1, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  /* ---------- Logo scroll story ---------- */
  var STOPS = [0, .22, .48, .72, 1];
  var K = {
    silver: [{x:-.314,y:0,z:-30,rz:-40.5,rx:0,ry:0,s:.78},{x:-.62,y:-.02,z:-160,rz:-6,rx:16,ry:32,s:.72},{x:-.5,y:-.26,z:-320,rz:-12,rx:8,ry:34,s:.62},{x:-.44,y:.06,z:-30,rz:-9,rx:0,ry:0,s:.74},{x:-.314,y:0,z:-30,rz:-40.5,rx:0,ry:0,s:.78}],
    gold:   [{x:.113,y:0,z:0,rz:-40.5,rx:0,ry:0,s:.78},{x:0,y:.02,z:60,rz:-3,rx:14,ry:-8,s:.82},{x:0,y:.02,z:140,rz:0,rx:4,ry:180,s:.98},{x:0,y:0,z:40,rz:0,rx:0,ry:360,s:.84},{x:.113,y:0,z:0,rz:-40.5,rx:0,ry:360,s:.78}],
    black:  [{x:.326,y:.031,z:-60,rz:49.5,rx:0,ry:0,s:.78},{x:.62,y:.08,z:-160,rz:6,rx:16,ry:-32,s:.72},{x:.5,y:.3,z:-320,rz:12,rx:8,ry:-34,s:.62},{x:.44,y:.06,z:-30,rz:9,rx:0,ry:0,s:.74},{x:.326,y:.031,z:-60,rz:49.5,rx:0,ry:0,s:.78}]
  };
  function sample(k, p) {
    var i = 0; while (i < STOPS.length - 2 && p > STOPS[i + 1]) i++;
    var t = ease(clamp((p - STOPS[i]) / (STOPS[i + 1] - STOPS[i]))), a = K[k][i], b = K[k][i + 1], o = {};
    for (var key in a) o[key] = lerp(a[key], b[key], t);
    return o;
  }
  function initStory(root) {
    if (root.dataset.msReady) return; root.dataset.msReady = '1';
    var stage = root.querySelector('[data-ms-stage]'), cards = {};
    root.querySelectorAll('[data-ms-card]').forEach(function (c) { cards[c.dataset.msCard] = c; });
    var caps = root.querySelectorAll('[data-ms-cap]'), dots = root.querySelectorAll('.ms__dots i'), hint = root.querySelector('[data-ms-hint]');
    var W = 300, SX = 1, last = -1, raf = 0, idxLast = -1;
    var bgWhen = root.dataset.bgWhen || 'designs';
    function progress() { var r = root.getBoundingClientRect(); return clamp(-r.top / Math.max(1, r.height - stage.parentNode.clientHeight)); }
    function paint(force) {
      raf = 0; var p = progress(); if (!force && Math.abs(p - last) < .0005) return; last = p;
      var e = clamp((p - .36) / .12) * (1 - clamp((p - .86) / .1));
      var lift = Math.sin(Math.PI * clamp(p / .95));
      var spread = Math.min(clamp(p / .15), clamp((1 - p) / .12)), xs = 1 - (1 - SX) * spread;
      for (var k in cards) {
        if (!K[k]) continue;
        var o = sample(k, p), c = cards[k];
        c.style.transform = 'translate3d(' + (o.x * W * xs).toFixed(1) + 'px,' + (o.y * W).toFixed(1) + 'px,' + o.z.toFixed(1) + 'px) rotateZ(' + o.rz.toFixed(2) + 'deg) rotateX(' + o.rx.toFixed(2) + 'deg) rotateY(' + o.ry.toFixed(2) + 'deg) scale(' + o.s.toFixed(3) + ')';
        c.style.setProperty('--e', e.toFixed(3)); c.style.setProperty('--lift', lift.toFixed(3)); c.style.setProperty('--sx', ((o.ry % 360) / 3 - 20).toFixed(1) + '%');
      }
      var idx = p < .12 ? 0 : p < .36 ? 1 : p < .6 ? 2 : p < .86 ? 3 : 4;
      if (idx !== idxLast) {
        idxLast = idx;
        caps.forEach(function (el, i) { el.classList.toggle('is-on', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
      }
      if (hint) hint.style.opacity = p > .04 ? 0 : 1;
      if (bgWhen === 'designs') root.style.setProperty('--bgv', (clamp((p - .5) / .14) * (1 - clamp((p - .86) / .1))).toFixed(3));
    }
    function size() {
      var vw = innerWidth, vh = stage.clientHeight;
      W = Math.round(Math.min(vw * .62, vh * .62, 380)); SX = Math.min(1, vw / (W * 2.3));
      root.style.setProperty('--w', W + 'px'); paint(true);
    }
    addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { paint(); }); }, { passive: true });
    addEventListener('resize', size); size();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { en.forEach(function (x) { document.body.classList.toggle('mc-in-story', x.isIntersecting); }); }, { threshold: 0 }).observe(root);
    }
  }

  /* ---------- Plastic vs steel ---------- */
  function initCompare(el) {
    if (el.dataset.mccReady) return; el.dataset.mccReady = '1';
    var dragging = false;
    function set(v) { v = Math.max(3, Math.min(97, v)); el.style.setProperty('--c', v + '%'); el.setAttribute('aria-valuenow', Math.round(v)); }
    function from(ev) { var r = el.getBoundingClientRect(); set((ev.clientX - r.left) / r.width * 100); }
    el.addEventListener('pointerdown', function (ev) { dragging = true; try { el.setPointerCapture(ev.pointerId); } catch (e) {} from(ev); });
    el.addEventListener('pointermove', function (ev) { if (dragging) from(ev); });
    el.addEventListener('pointerup', function () { dragging = false; });
    el.addEventListener('pointercancel', function () { dragging = false; });
    el.addEventListener('keydown', function (ev) {
      var v = parseFloat(el.getAttribute('aria-valuenow'));
      if (ev.key === 'ArrowLeft') { set(v - 5); ev.preventDefault(); }
      if (ev.key === 'ArrowRight') { set(v + 5); ev.preventDefault(); }
    });
    if (!reduce && 'IntersectionObserver' in window) {
      var nudged = false;
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (!x.isIntersecting || nudged) return; nudged = true;
          var t0 = performance.now();
          (function step(t) { var k = Math.min(1, (t - t0) / 1400); if (dragging) return; set(50 + Math.sin(k * Math.PI * 2) * 18 * (1 - k)); if (k < 1) requestAnimationFrame(step); })(t0);
        });
      }, { threshold: .6 }).observe(el);
    }
  }

  /* ---------- Wall of cards ---------- */
  function initWall(root) {
    if (root.dataset.mwReady) return; root.dataset.mwReady = '1';
    var tiles = Array.prototype.slice.call(root.querySelectorAll('.mw__tile'));
    var initial = parseInt(root.dataset.initial, 10) || 8, expanded = false, filter = 'all';
    var more = root.querySelector('[data-mw-more]');
    function apply() {
      var shown = 0;
      tiles.forEach(function (t) {
        var match = filter === 'all' || t.dataset.mwType === filter;
        var within = expanded || filter !== 'all' || shown < initial;
        t.hidden = !(match && within);
        if (match) shown++;
      });
      if (more) more.parentNode.hidden = expanded || filter !== 'all';
    }
    root.querySelectorAll('[data-mw-f]').forEach(function (ch) {
      ch.addEventListener('click', function () {
        root.querySelectorAll('[data-mw-f]').forEach(function (x) { x.setAttribute('aria-pressed', x === ch ? 'true' : 'false'); });
        filter = ch.dataset.mwF; apply();
      });
    });
    if (more) more.addEventListener('click', function () { expanded = true; apply(); });
    apply();

    tiles.forEach(function (t) {
      var inner = t.querySelector('.mw__in');
      t.addEventListener('pointermove', function (ev) {
        if (ev.pointerType !== 'mouse') return;
        var r = t.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width - .5, y = (ev.clientY - r.top) / r.height - .5;
        inner.style.setProperty('--ty', (x * 14) + 'deg'); inner.style.setProperty('--tx', (-y * 14) + 'deg');
      });
      t.addEventListener('pointerleave', function () { inner.style.setProperty('--ty', '0deg'); inner.style.setProperty('--tx', '0deg'); });
      t.addEventListener('click', function () { open(t); });
    });

    var count = root.querySelector('[data-mw-count]');
    if (count && !reduce && 'IntersectionObserver' in window) {
      var to = parseInt(count.dataset.mwCount, 10), suf = count.dataset.suffix || '', done = false;
      if (to > 0) new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (!x.isIntersecting || done) return; done = true;
          var t0 = performance.now(), from = Math.round(to * .75);
          (function step(t) { var k = Math.min(1, (t - t0) / 1300); count.textContent = Math.round(from + (to - from) * (1 - Math.pow(1 - k, 3))).toLocaleString('en-IN') + suf; if (k < 1) requestAnimationFrame(step); })(t0);
        });
      }, { threshold: .5 }).observe(count);
    }

    var lb = root.querySelector('[data-mw-lb]'), img = root.querySelector('[data-mw-img]'), title = root.querySelector('[data-mw-title]'), down = null, lastFocus = null;
    if (!lb) return;
    document.body.appendChild(lb); /* escape transformed ancestors */
    function open(t) {
      lastFocus = t; img.src = t.dataset.full; img.alt = t.dataset.title || ''; title.textContent = t.dataset.title || '';
      lb.hidden = false; document.body.classList.add('mc-lock'); lb.querySelector('[data-mw-close]').focus();
    }
    function close() {
      lb.hidden = true; document.body.classList.remove('mc-lock');
      img.style.setProperty('--rx', '0deg'); img.style.setProperty('--ry', '0deg');
      if (lastFocus) lastFocus.focus();
    }
    lb.querySelector('[data-mw-close]').addEventListener('click', close);
    lb.addEventListener('click', function (ev) { if (ev.target === lb) close(); });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !lb.hidden) close(); });
    img.addEventListener('pointerdown', function (ev) { down = { x: ev.clientX, y: ev.clientY }; try { img.setPointerCapture(ev.pointerId); } catch (e) {} });
    img.addEventListener('pointermove', function (ev) {
      var dx, dy;
      if (down) { dx = (ev.clientX - down.x) / 4; dy = (ev.clientY - down.y) / 4; }
      else if (ev.pointerType === 'mouse') { var r = img.getBoundingClientRect(); dx = ((ev.clientX - r.left) / r.width - .5) * 30; dy = ((ev.clientY - r.top) / r.height - .5) * 30; }
      else return;
      img.style.setProperty('--ry', Math.max(-30, Math.min(30, dx)) + 'deg'); img.style.setProperty('--rx', Math.max(-25, Math.min(25, -dy)) + 'deg');
    });
    function up() { down = null; img.style.setProperty('--rx', '0deg'); img.style.setProperty('--ry', '0deg'); }
    img.addEventListener('pointerup', up); img.addEventListener('pointercancel', up);
  }

  /* ---------- Builder: real card photos per finish ---------- */
  function initBuilderPhoto(root) {
    if (root.dataset.mcpReady) return; root.dataset.mcpReady = '1';
    var front = root.querySelector('[data-mc-bface]'), back = root.querySelector('[data-mc-bback]'), photo = root.querySelector('[data-mc-photo]');
    if (!front || !photo) return;
    function show(url) {
      var on = !!url;
      if (on) { var pre = new Image(); pre.onload = function () { photo.src = url; }; pre.src = url; }
      photo.hidden = !on;
      front.classList.toggle('has-photo', on);
      if (back) { back.classList.toggle('has-photo', on); back.style.backgroundImage = on ? 'url("' + url + '")' : ''; }
    }
    root.querySelectorAll('[data-mc-sw]').forEach(function (b) {
      b.addEventListener('click', function () { show(b.dataset.img || ''); });
    });
  }

  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-mc-story]').forEach(initStory);
    scope.querySelectorAll('[data-mc-compare]').forEach(initCompare);
    scope.querySelectorAll('[data-mc-wall]').forEach(initWall);
    scope.querySelectorAll('[data-mc-builder]').forEach(initBuilderPhoto);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
